export default "__VITE_ASSET__Wxyw4rAe__"